<div cdkDrag cdkDragRootElement=".modal-dialog">
<div class="modal-header" cdkDragHandle>
  <h4 class="modal-title">Excel Correlation Report (multiple groupings)</h4>
</div>

<div class="modal-body">
  <h6>Shared Criteria:</h6>
  <ul>
    <li><strong>Stage:</strong> {{sharedCriteria.stage}}</li>
    <li><strong>Building ID:</strong> {{sharedCriteria.buildingid}}</li>
    <li><strong>Participant:</strong> {{sharedCriteria.participant}}</li>
    <li *ngIf="sharedCriteria.routeid"><strong>Route ID:</strong> {{sharedCriteria.routeid}}</li>
  </ul>

  <h6 class="mt-3">Grouping Fields ({{groupingFields.length}}):</h6>
  <ul>
    <li *ngFor="let field of groupingFields">{{field}}</li>
  </ul>

  <p class="text-muted mt-2">
    <small>This will generate a merged report combining data from {{recordCount}} record(s) into a single dataset.</small>
  </p>

  <h6 class="mt-3">Date Range (optional):</h6>
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">Start Date</label>
    <div class="col-sm-9">
      <input type="date" class="form-control" [(ngModel)]="startDate">
    </div>
  </div>
  <div class="form-group row mt-2">
    <label class="col-sm-3 col-form-label">End Date</label>
    <div class="col-sm-9">
      <input type="date" class="form-control" [(ngModel)]="endDate">
    </div>
  </div>
  <p class="text-muted mt-1">
    <small>Leave blank to include all dates.</small>
  </p>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="onCancel()" [disabled]="isProcessing">
    Cancel
  </button>
  <button class="btn btn-primary" (click)="onContinue()" [disabled]="isProcessing">
    <span *ngIf="!isProcessing">Continue</span>
    <span *ngIf="isProcessing">Processing...</span>
  </button>
</div>
</div>
